// Sizes by product category (Settings → Database Lists → Size, "By category"). A category's size range lives on its
// Category list entry (entry.sizes); the Size list is the master list with one of each size. These helpers are used by
// the server (adding a size to a category, its garments, its measurement template and its Tech Packs) and the screen.
import { sortSizes } from "./items.js";

/** `size` put into `list` where it belongs by `order` (after the nearest size before it that `list` has).
 *  Sizes already in `list` (any capitals) leave it unchanged. */
export function insertSize(list: string[], size: string, order: string[]): string[] {
  if (list.some((s) => s.toLowerCase() === size.toLowerCase())) return [...list];
  const at = order.findIndex((s) => s.toLowerCase() === size.toLowerCase());
  if (at < 0) return [...list, size];
  for (let i = at - 1; i >= 0; i--) {
    const j = list.findIndex((s) => s.toLowerCase() === order[i].toLowerCase());
    if (j >= 0) return [...list.slice(0, j + 1), size, ...list.slice(j + 1)];
  }
  return [size, ...list];
}

/** Where a new size goes in a category's range: in size order among the range's sizes (5XL after 4XL, 30 after 28). */
export function placeInRange(range: string[], size: string): string[] {
  if (range.some((s) => s.toLowerCase() === size.toLowerCase())) return [...range];
  const sorted = sortSizes([...range, size]);
  return insertSize(range, size, sorted);
}

/** Sizes in the Size list that no category's range has (offered only to categories without a range of their own). */
export function sizesWithoutCategory(master: string[], ranges: string[][]): string[] {
  const used = new Set(ranges.flat().map((s) => s.toLowerCase()));
  return master.filter((s) => !used.has(s.toLowerCase()));
}

/** The garment's sizes that its Tech Pack doesn't have yet, in the garment's order. */
export function sizesMissingFromPack(garmentSizes: string[], packSizes: string[]): string[] {
  const have = new Set(packSizes.map((s) => s.toLowerCase()));
  return garmentSizes.filter((s) => !have.has(s.toLowerCase()));
}
